import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentTranscriptDetailsRoute from "./routes/StudentTranscriptDetails";

export default store => ({
  path: "records-by-student",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-records-by-student" */ "./components"
    ).then(m => m.default)
  ),

  childRoutes: [StudentTranscriptDetailsRoute(store)],
});
